import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';
import HomePage from './pages/HomePage';
import NosotrosPage from './pages/NosotrosPage';
import ServiciosPage from './pages/ServiciosPage';
import TalleresPage from './pages/TalleresPage';
import ContactoPage from './pages/ContactoPage';

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return localStorage.getItem('isLoggedIn') === 'true'; // Recuperar estado desde localStorage
  });
  const [embeds, setEmbeds] = useState([]);

  useEffect(() => {
    localStorage.setItem('isLoggedIn', isLoggedIn); // Guardar estado en localStorage
  }, [isLoggedIn]);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    localStorage.removeItem('isLoggedIn'); // Eliminar estado de autenticación
  };

  const handleAddEmbed = (embedLink) => {
    setEmbeds([...embeds, embedLink]);
  };

  const handleDeleteEmbed = (index) => {
    setEmbeds(embeds.filter((_, i) => i !== index));
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/inicio" replace />} />
        <Route path="/inicio" element={<HomePage />} />
        <Route path="/nosotros" element={<NosotrosPage />} />
        <Route path="/servicios" element={<ServiciosPage />} />
        <Route path="/talleres" element={<TalleresPage />} />
        <Route path="/contacto" element={<ContactoPage />} />

        <Route path="/login" element={<LoginPage onLoginSuccess={handleLoginSuccess} />} />

        <Route
  path="/admin"
  element={
    isLoggedIn ? (
      <AdminPage
        embeds={embeds}
        onAddEmbed={handleAddEmbed}
        onDeleteEmbed={handleDeleteEmbed}
        isLoggedIn={isLoggedIn}
        onLogout={handleLogout}
      />
    ) : (
      <Navigate to="/login" replace />
    )
  }
/>
      </Routes>
    </Router>
  );
};

export default App;